import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "emissions",
  initialState: {
    data: null,
  },
  reducers: {
    setEmissionsData: (state, { payload: data }) => {
      return {
        ...state,
        data,
      };
    },
  },
});

export const { setEmissionsData } = slice.actions;

export default slice.reducer;

export const getEmissionsDataSelector = (store) => {
  return store.emissions?.data || null;
};
